import { useContext, useEffect, useState } from 'react'
import { trainingService } from 'api/services/trainings'
import { TrainingItem } from 'api/types/trainings'
import { Rocket } from 'components/Icons/rocket'
import { AppContext } from 'contexts/AppContext'
import { Badge, Button, toast } from 'keep-react'
import { format } from 'date-fns'

export const Trainings = () => {
  const { settings } = useContext(AppContext)
  const [data, setData] = useState<TrainingItem | null>(null)

  const getTraining = async () => {
    if (!settings?.dashboardTraining) return
    try {
      const response = (await trainingService.getTraining({
        id: settings.dashboardTraining,
      })) as TrainingItem
      setData(response as TrainingItem)
    } catch (error) {
      toast.error('Não foi possível carregar a formação.')
      console.error('Não foi possível carregar a formação.', error)
    }
  }

  useEffect(() => {
    getTraining()
  }, [settings])

  if (!data) return null

  return (
    <div className="p-4 bg-white h-full">
      <div>
        <div className="grid grid-cols-[16px_1fr] items-start gap-2">
          <span className="pt-1.5">
            <Rocket />
          </span>
          <div className="space-y-4">
            <h2 className="text-body-1 uppercase">FORMAÇÕES</h2>
            <h3 className="text-body-3 font-bold text-primary-500 pb-1">
              {data.name}
            </h3>

            <p className="text-body-4 text-metal-600 font-medium">
              No dia{' '}
              <strong>{format(new Date(data.date!), 'dd/MM/yyyy')}</strong> às{' '}
              <strong>{format(new Date(data.date!), 'HH:mm')}</strong> <br />
              formador(es): <strong>{data.teacher}</strong>
            </p>
            <p className="text-body-4 text-metal-600 font-medium">
              {data.description}
            </p>
            {data.isUserRegistered ? (
              <Badge
                color="secondary"
                variant="base"
                className="px-4 py-2 text-body-4 pointer-events-none"
              >
                Já se inscreveu nesta formação!
              </Badge>
            ) : (
              <Button color="primary" variant="softBg">
                inscrever agora
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
